import axios from "axios";
import config from "../config";

// Header có Bearer token (nếu có)
const authHeaders = () => {
  const token = localStorage.getItem("token");
  return { Authorization: `Bearer ${token || ""}` };
};

// GET /api/products  (hỗ trợ query nếu sau này cần)
export const getProducts = async (params = {}) => {
  try {
    const res = await axios.get(`${config.apiBaseUrl}/products`, {
      headers: authHeaders(),
      params,
    });
    return res.data; // IEnumerable<ProductDto>
  } catch (error) {
    console.error("❌ Lỗi khi lấy danh sách sản phẩm:", error);
    throw error;
  }
};
